import React from 'react';

const LocationPinIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14 6C14 10.5 8.5 15.5 8.5 15.5C8.5 15.5 3 10.5 3 6C3 4.54131 3.57946 3.14236 4.61091 2.11091C5.64236 1.07946 7.04131 0.5 8.5 0.5C9.95869 0.5 11.3576 1.07946 12.3891 2.11091C13.4205 3.14236 14 4.54131 14 6V6Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.5 8.5C9.88071 8.5 11 7.38071 11 6C11 4.61929 9.88071 3.5 8.5 3.5C7.11929 3.5 6 4.61929 6 6C6 7.38071 7.11929 8.5 8.5 8.5Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default LocationPinIcon;
